module.exports = __webpack_public_path__ + "static/media/main__close.e35fef7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/main__close.png
// module id = 1850
// module chunks = 6